export enum Capabilities {
    PRICE_TAGS_MANAGE = 'price_tags_manage',
    PRICE_TAGS_SHOW = 'price_tags_show',
}
